import { api } from "@/lib/api";

const SW_URL = "/sw.js";
export const pushSupported = () => typeof window !== "undefined" && "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
export const notificationsSupported = () => typeof window !== "undefined" && "Notification" in window;

function toKey(base64Url) {
  const padding = "=".repeat((4 - (base64Url.length % 4)) % 4);
  const base64 = (base64Url + padding).replace(/-/g, "+").replace(/_/g, "/");
  return Uint8Array.from([...window.atob(base64)].map((c) => c.charCodeAt(0)));
}

export async function getPushSubscription() {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.getRegistration(SW_URL);
  return reg ? reg.pushManager.getSubscription() : null;
}

export async function enablePush() {
  if (!pushSupported()) throw new Error("This browser does not support Web Push.");
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Notification permission was denied.");
  const reg = await navigator.serviceWorker.register(SW_URL);
  await navigator.serviceWorker.ready;
  const { data } = await api.get("/push/public-key");
  if (!data.enabled) throw new Error("Push is not configured on the server.");
  let sub = await reg.pushManager.getSubscription();
  if (!sub) sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: toKey(data.publicKey) });
  await api.post("/push/subscribe", sub.toJSON());
  return sub;
}

export async function disablePush() {
  const sub = await getPushSubscription();
  if (!sub) return;
  await api.delete("/push/subscribe", { data: sub.toJSON() }).catch(() => {});
  await sub.unsubscribe();
}

export function showTabNotification(title, body, url = "/dashboard") {
  if (!notificationsSupported() || Notification.permission !== "granted") return;
  const n = new Notification(title, { body, icon: "/icon-192.png", tag: `${title}-${body}`.slice(0, 64) });
  n.onclick = () => {
    window.focus();
    window.location.href = url;
  };
}
